export { AboutUsFeature } from './lib/about-us'
export { getStaticProps } from './lib/get-static-props'
export type { AboutUsFeatureProps } from './lib/get-static-props'
export type { AboutUsStoryContent } from './lib/types/about-us-page'
